import { render } from "./MpidTable.vue?vue&type=template&id=4eb104dc&scoped=true"
import script from "./MpidTable.vue?vue&type=script&lang=js"
export * from "./MpidTable.vue?vue&type=script&lang=js"

import "./MpidTable.vue?vue&type=style&index=0&id=4eb104dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb104dc"]])

export default __exports__